
























import Vue from "vue";
import { mapGetters } from "vuex";

// Component
import NotificationSubscriptionCard from "./NotificationSubscriptionCard.vue";
import ReportSubscriptionCard from "./ReportSubscriptionCard.vue";
import UserLongTasksCard from "./UserLongTasksCard.vue";
import UserProfileCard from "./UserProfileCard.vue";

// Model
import { ClientPrivileges } from "@/model/data/authentication/ClientPrivilegesEnum";

export default Vue.extend({
    components: {
        UserProfileCard,
        NotificationSubscriptionCard,
        ReportSubscriptionCard,
        UserLongTasksCard,
    },
    computed: {
        ...mapGetters(["authUserHasPrivilege"]),
        reportSubscriptionEnabled() {
            return (
                this.authUserHasPrivilege(ClientPrivileges.CashFlowContentMonitoring) ||
                this.authUserHasPrivilege(ClientPrivileges.CashFlowTransactionsReporting) ||
                this.authUserHasPrivilege(ClientPrivileges.PlatformMaintenance)
            );
        },
        notificationSubscriptionEnabled() {
            return (
                this.authUserHasPrivilege(ClientPrivileges.CashFlowContentMonitoring) ||
                this.authUserHasPrivilege(ClientPrivileges.StatusManagement) ||
                this.authUserHasPrivilege(ClientPrivileges.SmartLockManagement)
            );
        },
    },
    data() {
        return {
            ClientPrivileges,
        };
    },
});
